import styled from "styled-components";
import { ButtonsContainer } from "../style";

export const PhotoContatiner = styled(ButtonsContainer)``;

export const Uploader = styled.input`
  display: none;
`;
